import {Component} from '@angular/core';
import {NavigationService} from './navigation.service';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  requisitesVisibility = false;
  aboutVisibility = false;
  tariffVisibility = false;
  howToRide = false;

  constructor(
    public navigationService: NavigationService,
    public router: Router
  ) {
    if (this.router.url.startsWith('/kz')) {
      this.tariffVisibility = true;
    }
    if (
      this.router.url !== '/rental-all'
      && this.router.url !== '/electric-scooters-rental-agreement'
      && this.router.url !== '/privacy-all'
      && this.router.url !== '/license-all'
      && this.router.url !== '/terms-of-use'
      && this.router.url !== '/insurance'
      && this.router.url !== '/parts'
      && this.router.url !== '/payment-information'
      && this.router.url !== '/how-to-ride'
    ) {
      this.aboutVisibility = true;
    }
    if (this.router.url.startsWith('/ru')) {
      this.requisitesVisibility = true;
      this.tariffVisibility = true;
      this.howToRide = true;
      this.aboutVisibility = false;
    }
  }

  toAbout(): void {
    if (this.navigationService.about) {
      this.navigationService.about.scrollIntoView();
      this.navigationService.openMenu.next(false);
    } else {
      const url = this.router.url.split('/');
      this.router.navigate([url[1]]);
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            this.navigationService.about.scrollIntoView();
            this.navigationService.openMenu.next(false);
          }, 0);
        }
      });
    }
  }

  toTariff(): void {
    if (this.navigationService.tariff) {
      this.navigationService.tariff.scrollIntoView();
      this.navigationService.openMenu.next(false);
    } else {
      const url = this.router.url.split('/');
      this.router.navigate([url[1]]);
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            this.navigationService.tariff.scrollIntoView();
            this.navigationService.openMenu.next(false);
          }, 0);
        }
      });
    }
  }
}
